<div class="flex items-center">
  <button (click)="open()" mat-icon-button>
    <iconify-icon [icon]="icSearch" class="notifications-header-icon"></iconify-icon>
  </button>

  <mat-form-field
    [class.search-open]="isOpen"
    appearance="outline"
    class="search flex-1">
    <mat-label>Search&hellip;</mat-label>
    <input #input (blur)="close()" matInput>
  </mat-form-field>
</div>
